@let savingDrawer = savingDrawer$ | async;
<nz-drawer
  [nzVisible]="(bulkEditDrawerVisible$ | async) === true"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzPlacement]="'right'"
  [nzClosable]="false"
  [nzTitle]="'general.edit' | translate"
  [nzSize]="'large'"
  [nzFooter]="drawerFooter"
  (nzOnClose)="closeBulkCreateEditDrawer()"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical">
      <wilson-bulk-edit-qualifications-selection-list></wilson-bulk-edit-qualifications-selection-list>

      <hr />

      <wilson-bulk-qualifications-dates-and-approval-section
        [acquiredAtFormControl]="acquiredAtFormControl"
        [validFromFormControl]="validFromFormControl"
        [validUntilFormControl]="validUntilFormControl"
        [infiniteValidFormControl]="infiniteValidFormControl"
        [confirmedByEmployeeFormControl]="confirmedByEmployeeFormControl"
        [hasMixedValues]="selectionHasMixedValues"
      ></wilson-bulk-qualifications-dates-and-approval-section>

      <hr />

      <wilson-bulk-qualifications-attachment-section
        [(fileList)]="attachmentsList"
        [disabledNzUpload]="savingDrawer"
        [disabledFileList]="savingDrawer"
      ></wilson-bulk-qualifications-attachment-section>

      <hr />

      <wilson-bulk-qualifications-notes-section
        [notesFormControl]="notesFormControl"
        [hasMixedValues]="selectionHasMixedValues"
      ></wilson-bulk-qualifications-notes-section>
    </form>
  </ng-container>
</nz-drawer>

<ng-template #drawerFooter>
  <wilson-bulk-qualifications-footer-section
    (cancelDrawer)="cancelDrawer()"
    (saveDrawer)="saveDrawer()"
    [saveButtonDisabled]="
      !(
        ((acquiredAtFormControl.dirty && acquiredAtFormControl.value) ||
          (validFromFormControl.dirty && validFromFormControl.value) ||
          (validUntilFormControl.dirty && validUntilFormControl.value) ||
          (infiniteValidFormControl.dirty &&
            infiniteValidFormControl.value === false &&
            validUntilFormControl.value) ||
          (infiniteValidFormControl.dirty && infiniteValidFormControl.value) ||
          confirmedByEmployeeFormControl.dirty ||
          notesFormControl.dirty ||
          haveAttachmentsChanged()) &&
        acquiredAtFormControl.valid &&
        validFromFormControl.valid &&
        validUntilFormControl.valid
      )
    "
    [loading]="savingDrawer"
  ></wilson-bulk-qualifications-footer-section>
</ng-template>
